(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[886,1674],{

/***/ 99877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]",
      function () {
        return __webpack_require__(20358);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var DomainExpired = function(props) {
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "vh-100 flex justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "absolute top-0 w-100 mt0 f14px black-70 h3 tr pt2 flex flex-column flex-row-ns justify-center justify-end-ns items-end items-center-ns ph3",
                children: [
                    "Log In, If you are the owner of this website",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "black ph14px pv8px ba br3 b--black-40 ml4 mt2 mt0-ns f6-ns f12px pa2 link",
                        href: "https://download.digitalshowroom.app/RequestCall",
                        children: "Log In"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "ph3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "tc flex justify-center flex-column flex-row-ns items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
                                className: "img h3 mr0 mr3-ns"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("lable", {
                                className: "f30px",
                                children: (ref2 = props.storeInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.store_info) === null || ref3 === void 0 ? void 0 : ref3.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "f24px fw6 tc",
                        children: "Hi, We are unavailable at the moment."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "f22px fw3 tc",
                        children: [
                            " ",
                            "We will be back very soon. Inconvenience is regretted."
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DomainExpired);


/***/ }),

/***/ 20358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _containers_Home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32997);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25291);
/* harmony import */ var _components_DomainExpired__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68728);
/* harmony import */ var _utils_getWebpageTitle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61233);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55847);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35449);
/* harmony import */ var url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66162);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68037);
/* harmony import */ var _utils_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15483);
/**
 * Product Page
 */ 














var Product = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var allProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        storeInfo: storeInfo
    });
    var reduxStoreData = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    });
    var isPreview = (0,_utils_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) !== (reduxStoreData === null || reduxStoreData === void 0 ? void 0 : reduxStoreData.store_id)) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_11__/* .emptyCart */ .UY)());
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        store: storeInfo,
        title: storeInfo && (0,_utils_getWebpageTitle__WEBPACK_IMPORTED_MODULE_12__/* .getWebpageTitle */ .e)(storeInfo, props.seo),
        keywords: props.seo ? props === null || props === void 0 ? void 0 : (ref = props.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.keywords) === null || ref1 === void 0 ? void 0 : ref1.toString() : "",
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.logo_image,
        favIcon: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.favicon,
        metaDescription: (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_13__/* .getMetaDescription */ .w)(storeInfo, props.seo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.logo_image,
        isCustomDomain: props.isCustomDomain,
        storeInfo: storeInfo,
        canonicalTagUrl: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_url
    }, allProps), {
        children: !isPreview && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.domain_info) === null || ref4 === void 0 ? void 0 : ref4.status) === 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DomainExpired__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            storeInfo: storeInfo
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Home__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, allProps))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Product);


/***/ }),

/***/ 61233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getWebpageTitle; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getWebpageTitle = function(storeInfo, seoDetails) {
    var ref;
    // const businessTypes = storeInfo.store_businesses;
    if (seoDetails) return seoDetails.title.value;
    var title = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_title;
    return title || "";
// let storeAddressCity = '';
// if (storeInfo?.address?.visibility === 1 && storeInfo?.address?.city)
//   storeAddressCity = `, ${storeInfo?.address?.city}`;
// return `${storeInfo?.store_info?.name}${storeAddressCity} - ${
//   businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16
//     ? 'Real Estate Property'
//     : 'Order Online'
// }`;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,8388,1562,5843,6379,4814,6576,8487,1033,5291,3978,537,6825,1242,2031,3973,7909,4640,6235,2265,6556,9774,2888,179], function() { return __webpack_exec__(99877); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);